import React from 'react';
import './Popup.scss';

class Popup extends React.Component {
    render() {
        return (
            // <div className='popup'>  
            //     <div className='popup\_inner'>  
            //         <h1>{this.props.text}</h1>  
            //         <button className="ui submit small green button left" onClick={this.props.closePopup}>Done</button>  
            //     </div>  
            // </div>

            <>
            
                    <div
                        className="signup-modal__overlay"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="signup-modal__title"
                    >
                        <div className="signup-modal__container">
                            <div className="signup-modal__content">
                                <div className="signup-modal__header">
                                    <h3
                                        className="signup-modal__title"
                                        id="signup-modal__title"
                                    >
                                        Terms of Service
                                    </h3>
                                    <button
                                        type="button"
                                        className="signup-modal__close-button"
                                        onClick={this.props.closePopup}
                                        aria-label="Close modal"
                                    >
                                        <svg className="signup-modal__close-icon" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                stroke="currentColor"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M1 1L13 13M13 1L1 13"
                                            />
                                        </svg>
                                        <span className="signup-modal__sr-only">Close modal</span>
                                    </button>
                                </div>

                               
                                <div className="signup-modal__body">
                                    {this.props.text}
                                </div>

                          
                                <div className="signup-modal__footer">
                                    <button onClick={this.props.closePopup} className="signup-modal__accept-button">
                                        Done
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                
            </>

        );
    }
}

export default Popup;